import { ProductCard } from '@components/ProductCard';

import { CmsProductPageDocument } from '@interfaces/common';

import styles from './ProductGrid.module.css';

interface ProductGridProps {
	products: CmsProductPageDocument[];
}

export const ProductGrid: React.VFC<ProductGridProps> = ({ products }) => {
	return (
		<ul className={styles.list}>
			{products.map((product) => (
				<li key={product.title}>
					<ProductCard
						{...product}
						backgroundColor={product.category.highlightColor}
						locale={product.__i18n_lang}
						packshot={product.packshot}
						slug={product.slug}
					/>
				</li>
			))}
		</ul>
	);
};
